export default "__VITE_PUBLIC_ASSET__6c2025e6__"